// getImageUrl must be in a seperate file so instrumentation.page.ts can import it
// otherwise there are issues that stem from the import of next-intl
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
const STATIC_ASSETS_PREFIX = publicRuntimeConfig.app.assets.prefix;

export const getImageUrl = (path: string) => {
  return STATIC_ASSETS_PREFIX ? `${STATIC_ASSETS_PREFIX}${path}` : path;
};
